// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__1kHo0","contained":"OpenButton_contained__2Rd8l","disabled":"OpenButton_disabled__2ogIm","error":"OpenButton_error__2OU2u"};